<template>
  <div>
    <div class="master-detail-caption"></div>
    <DxDataGrid
      :data-source="structures"
      :show-borders="true"
      key-expr="Id"
      :column-auto-width="true"
      @row-updating="onRowUpdating"
    >
      <DxPaging :page-size="20" />
      <DxEditing
        :allow-updating="true"
        mode="cell"
        :select-text-on-edit-start="true"
        :start-edit-action="startEditAction"
      />
      <DxColumn
        data-field="StructureDto.Description"
        caption="Δομή"
        :allow-editing="false"
        alignment="left"
      />
      <DxColumn
        caption="Ενεργή"
        data-field="IsActive"
        data-type="boolean"
        width="150px"
        alignment="center"
      />
    </DxDataGrid>
  </div>
</template>
<script>
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  components: { DxDataGrid, DxColumn, DxEditing, DxPaging },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      structures: [],
      startEditAction: "click",
    };
  },
  async mounted() {
    await this.getMobileStructures();
  },
  methods: {
    async getMobileStructures() {
      debugger;
      var mobileId = this.templateData.data.Id;
      var res = await mainService.get(
        `/MobileStructures/GetMobileStructuresByMobile?mobileId=${mobileId}`
      );
      this.structures = res.data;
    },
    async onRowUpdating(e) {
      var mobileStructure = Object.assign(e.oldData, e.newData);
      mobileStructure.Id = e.key;

      try {
        const res = await mainService.post(
          "/MobileStructures/UpdateMobileStructure",
          mobileStructure
        );
        if (res.status != 200) {
          e.cancel = true;
        } else {
          //console.log(res.data);
        }
      } catch (error) {
        console.log(error);
        e.cancel = true;
      }
    },
  },
};
</script>

<style>
.master-detail-caption {
  padding: 0 0 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.dx-header-row {
  font-weight: bold;
}
</style>
